import { Card, CardColors, Image, Text } from '@/ui'
import { AhaMomentsHeaderFooter } from '../AhaMomentsHeaderFooter'
import { TypographyStyles } from '@/styles'

export const TransactionsClarifiedSuccess = ({
  handleContinue,
  handleBack,
}: {
  handleContinue: () => void
  handleBack: () => void
}) => {
  return (
    <AhaMomentsHeaderFooter
      backButtonText={'Back'}
      continueButtonText={'Complete'}
      handleContinue={handleContinue}
      handleBack={handleBack}
    >
      <div className="flex flex-col items-center p-0 mx-auto">
        <div className="w-full md:w-2/3 lg:w-7/12">
          <Text variant={TypographyStyles.H2} className="mb-4">
            Learn How Bookkeeping Works
          </Text>
          <Card color={CardColors.EMPHASIS}>
            <div className="flex flex-col md:flex-row">
              <Image
                className="w-full md:w-1/4 mr-2.5 flex items-center"
                src="https://heard-images.s3.amazonaws.com/assets/check.svg"
                alt="Checkmark"
              />
              <div className="w-full md:flex-1">
                <Text variant={TypographyStyles.H3}>
                  Nice work! You know how to identify personal transactions
                </Text>
                <br />
                <Text>
                  Once your books are complete, you will be able to see full
                  reports and financial insights on your therapy business.
                  We&apos;ll let you know if you need to clarify anything else.
                </Text>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </AhaMomentsHeaderFooter>
  )
}

export default TransactionsClarifiedSuccess
